import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Configuración de Firebase para Lecta
const firebaseConfig = {
  apiKey: "AIzaSyAUsnhghBexVA1gaZHxs_YMngsOVGozzHU",
  authDomain: "lecta-3f1c4.firebaseapp.com",
  projectId: "lecta-3f1c4",
  storageBucket: "lecta-3f1c4.firebasestorage.app",
  messagingSenderId: "566498555498",
  appId: "1:566498555498:web:a5a3b3f2a5b5c5d5e5f5g5"
};

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Exportar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
